module.exports = __webpack_public_path__ + "img/product-6.9c05b921.png";